import React from 'react';
import CheckIcon from './icons/CheckIcon';
import '../styles/Document.scss';
import Document from './MessageTypes/Document';

const DocumentMessage = ({ src, time, senderType, caption, selectedColor }) => {
  return (
    <div
      className={`flex flex-col mb-2 ${
        senderType === 'user' ? 'items-end ' : 'items-start'
      }`}
    >
      <div
        className={`text-sm p-2 break-words rounded-tl-2xl rounded-tr-2xl max-w-[75%] md:max-w-[50%] lg:max-w-[70%] ${
          senderType === 'user'
            ? 'text-white rounded-bl-2xl'
            : 'bg-callbell-light-gray text-black rounded-br-2xl'
        }`}
      >
        <Document src={src} />
        <div className="pt-1">{caption}</div>
      </div>
      <div className="flex text-xs text-gray-300 p-1">
        {senderType === 'user' && <CheckIcon alt="Checkmark" className="w-4 h-4" />}
        <div>{`${senderType === 'user' ? 'Uploaded' : ''} ${time}`}</div>
      </div>
    </div>
  );
};

export default DocumentMessage;
